module.exports = __webpack_public_path__ + "img/icon-csv.dbb45301.png";